import { useIntercom } from "react-use-intercom";

import {
  AGENCY_INCLUDED_SEATS,
  PRICING_PLANS,
} from "features/subscriptions/constants";

import Alert from "common/components/ui/Alert";
import { Button } from "common/components/ui/Button";
import { formatShortDate } from "common/helpers/utils";
import type {
  AgencySubscription,
  RentedSubscription,
  Subscription,
} from "common/types";

export default function AlertBanners({
  currentSubscription,
  quantity,
  isDowngrade,
  isYearlyToMonthly,
}: {
  currentSubscription: Subscription | RentedSubscription | AgencySubscription;
  quantity: number;
  isDowngrade: boolean;
  isYearlyToMonthly: boolean;
}) {
  const { showNewMessage } = useIntercom();

  const { type, status } = currentSubscription;

  if (status === "in_trial") {
    return (
      <Alert variant="gradient">
        You will not be charged until your trial expires. Your subscription will
        automatically upgrade to a paid plan on{" "}
        {formatShortDate(currentSubscription.next_billing * 1000)}
      </Alert>
    );
  }

  if (status !== "cancelled") {
    if (isYearlyToMonthly) {
      return (
        <Alert variant="warning">
          Please contact support to downgrade your yearly subscription to
          monthly
        </Alert>
      );
    } else if (isDowngrade) {
      if (type === "user") {
        return (
          <Alert variant="warning">
            This is a scheduled change. Your subscription will be updated on the
            next billing date
          </Alert>
        );
      } else {
        const planName = PRICING_PLANS[type].name;
        return (
          <Alert variant="warning">
            <div className="flex flex-col gap-y-1.5">
              <span>
                The {planName} cannot be downgraded through the dashboard,
                please contact our team to downgrade your subscription
              </span>
              <Button
                variant="secondary-black"
                size="sm"
                className="ml-auto"
                onClick={() => {
                  showNewMessage(
                    `Hello, i would like to cancel my ${planName} seats`,
                  );
                }}
              >
                Contact support
              </Button>
            </div>
          </Alert>
        );
      }
    }
  }

  if (type === "agency" && quantity === AGENCY_INCLUDED_SEATS) {
    return (
      <Alert>Subscription is currently at the minimum number of seats</Alert>
    );
  }
}
